import { RumInitConfiguration } from "@datadog/browser-rum";

export const getDatadogRumOptions = (
  env: ImportMetaEnv = import.meta.env
): RumInitConfiguration | undefined => {
  if (env.VITE_ANALYTICS_ENABLED !== "true" || env.VITE_DATADOG_ENABLED !== "true") {
    return undefined;
  }
  return {
    applicationId: "7f622dbe-dbb4-4a8b-a84f-b04a06dbe020",
    clientToken: "pub8bc8a0e03e4d24e31f47b86a78e8d94b",
    site: "datadoghq.com",
    service: "email-login",
    env: env.VITE_ANALYTICS_ENV,
    version: env.VITE_ANALYTICS_VERSION || "dev",
    traceSampleRate: 100,
    trackUserInteractions: true,
  };
};
